import { useEffect, useRef, useState } from "react";
import { API, fileUpload } from "../../../config";

export const YodleeConnectModal = ({
  fastLinkData,
  trustId,
  setLoading,
  openYodlee,
  handleYodleeModal,
  fetchIntegration,
}) => {
  const hasOpenedFastlink = useRef(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const handleSaveAccounts = async (providersData) => {
    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.SAVE_ACCOUNTS}`, {
        trust_id: trustId,
        // yodlee_providers: providersData,
      });
      setLoading(false);
      if (data) {
        handleYodleeModal();
        fetchIntegration();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // Load FastLink script ONCE
  useEffect(() => {
    if (window.fastlink) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://cdn.yodlee.com/fastlink/v4/initialize.js";
    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);
  }, []);

  // Main FastLink handler
  useEffect(() => {
    const containerId = "container-fastlink";

    if (
      openYodlee &&
      fastLinkData?.accessToken &&
      window.fastlink &&
      scriptLoaded &&
      !hasOpenedFastlink.current
    ) {
      // Clear container to avoid DOM reuse issues
      const el = document.getElementById(containerId);
      if (el) el.innerHTML = "";

      hasOpenedFastlink.current = true;

      try {
        window.fastlink.open(
          {
            fastLinkURL: fastLinkData.fastLinkURL,
            accessToken: fastLinkData.accessToken,
            params: {
              ...fastLinkData.params,
              container: containerId,
            },
            onSuccess: (data) => {
              console.log("✅ FastLink success:", data);
            },
            onError: (data) => {
              const message =
                data?.message || data?.description || "Unknown error";
              console.log(message);
            },
            onClose: async (providersData) => {
              hasOpenedFastlink.current = false;
              providersData?.sites &&
                providersData?.sites?.length > 0 &&
                handleSaveAccounts(providersData?.sites);

              handleYodleeModal();
            },
            onEvent: (data) => {
              console.log("📢 FastLink event", data);
            },
          },
          "container-fastlink"
        );
      } catch (e) {
        console.error("FastLink error:", e);
        hasOpenedFastlink.current = false;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openYodlee, fastLinkData, scriptLoaded]);

  return openYodlee ? (
    <div className="flex items-center justify-center w-full">
      {fastLinkData?.fastLinkURL && (
        <div
          id="container-fastlink"
          className="h-full max-w-[900px] w-full bg-white p-3 rounded-md border"
          key="fastlink-container"
        ></div>
      )}
    </div>
  ) : null;
};
